"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _isEmail = _interopRequireDefault(require("validator/lib/isEmail"));

var _genericInput = _interopRequireDefault(require("./generic-input"));

var getEmailValidationFn = function getEmailValidationFn(invalidEmailMsg) {
  if (invalidEmailMsg === void 0) {
    invalidEmailMsg = "Please enter a valid email address";
  }

  return function (value) {
    if (!(0, _isEmail["default"])(value)) {
      return {
        valid: false,
        errorMessage: invalidEmailMsg
      };
    }

    return {
      valid: true,
      errorMessage: ""
    };
  };
};

var EmailInput = function EmailInput(_ref) {
  var invalidEmailMsg = _ref.invalidEmailMsg,
      genericInputProps = (0, _objectWithoutPropertiesLoose2["default"])(_ref, ["invalidEmailMsg"]);
  return _react["default"].createElement(_genericInput["default"], (0, _extends2["default"])({}, genericInputProps, {
    inputType: "email",
    validator: getEmailValidationFn(invalidEmailMsg)
  }));
};

EmailInput.defaultProps = {
  labelText: "Email",
  inputId: "email",
  inputName: "email"
};
var _default = EmailInput;
exports["default"] = _default;